import { GAME_ID, ACTION_TYPES } from 'a/stickerBook/data/constants';

/**
 * This reducer manages state for information saved to S3 in JSON for audio and
 * content.
 */

const initialState = {
  // Curriculum will be spread here
  curriculum: {
    /**
     * levels: [
     *   {
     *     assets: [{ file, name, path }],
     *     items: [{
     *       assetId,
     *       category,
     *       categoryAudio,
     *       connectorAudio,
     *       definitionAudio,
     *       height,
     *       width,
     *       word,
     *       wordAudio,
     *     }],
     *     level: 0,
     *     mastery: 7,
     *     mode: "",
     *     questSet: 0,
     *     scenes: [{ background, sceneId }],
     *   }
     * ]
     */
  },
  // Audio map
  audioMap: {},
};

export default (state = initialState, { gameId, type, payload }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case ACTION_TYPES.LOAD_CURRICULUM:
      return { ...state, ...payload };
    default:
      return state;
  }
};
